import { DateTime } from 'luxon'

const DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm:ss'

export function getFormattedTimestampInUTC (timeInMillis: number): string {
  return DateTime.fromMillis(timeInMillis).setZone("UTC").toFormat(DATE_TIME_FORMAT)
}

export function getFormattedCurrentTimestampInUTC (): string {
  return DateTime.now().setZone("UTC").toFormat(DATE_TIME_FORMAT)
}

export function getTimeFromUTCFormattedTimestamp (formattedTimestamp: string): number {
  return DateTime.fromFormat(formattedTimestamp, DATE_TIME_FORMAT, {zone: "UTC"}).valueOf()
}

export function getDateFromIsoFormat (formattedTimestamp: string): Date {
  return DateTime.fromISO(formattedTimestamp).toJSDate()
}
